import { render, staticRenderFns } from "./section-update-list-item.vue?vue&type=template&id=39039df6&"
import script from "./section-update-list-item.vue?vue&type=script&lang=ts&"
export * from "./section-update-list-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports